import * as BABYLON from "babylonjs"
import * as GUI from "babylonjs-gui"

export class ColourPicker {
	static create(
		scene: BABYLON.Scene,
		engine: BABYLON.Engine,
		id: string,
		position: [number, number, number],
		size: number, // The size parameter now refers to the size of the plane
		onColourChanged: (newColour: string) => void, // Callback function for when the colour changes
		grabbable: boolean = false, // Whether the color picker should be draggable
		visibility: boolean,
		parentID?: string // New parameter for parent ID
	): void {
		const plane = BABYLON.MeshBuilder.CreatePlane(
			`${id}_plane`,
			{ width: size, height: size }, // Use the size parameter to define the plane size
			scene
		)
		plane.position = new BABYLON.Vector3(position[0], position[1], position[2])

		// Adjust the engine's rendering resolution to improve the GUI element's clarity
		// This is particularly useful for high-DPI displays
		//engine!.setHardwareScalingLevel(1 / window.devicePixelRatio)

		// Create an advanced texture for the GUI container with a higher resolution
		// This ensures the GUI elements rendered on it are less likely to become pixelated upon scaling
		const advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(
			plane,
			1024,
			1024
		)
		advancedTexture.idealWidth = 1024 // Adjust these values based on your needs and testing
		advancedTexture.idealHeight = 1024

		// Create the colour picker with the GUI system
		const colourPicker = new GUI.ColorPicker()
		colourPicker.value = new BABYLON.Color3(0.5, 0.5, 0.5)
		colourPicker.width = "100%"
		colourPicker.height = "100%"
		colourPicker.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER
		colourPicker.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER

		// Handle colour changes
		colourPicker.onValueChangedObservable.add((value) => {
			onColourChanged(value.toHexString())
		})
		if (engine != null) {
			// Add the colour picker to the advanced texture
			advancedTexture.addControl(colourPicker)
		}

		// Setting the parent if parentID is provided
		if (parentID) {
			const parentMesh = plane._scene!.getMeshByID(parentID) as BABYLON.Mesh
			if (parentMesh) {
				plane.parent = parentMesh
			}
		}
		if (grabbable) {
			// Instead of PointerDragBehavior, use SixDofDragBehavior for 3D dragging
			const dragBehavior = new BABYLON.SixDofDragBehavior()
			plane.addBehavior(dragBehavior)

			dragBehavior.onDragStartObservable.add(() => {
				console.log("3D dragging started")
			})
			// No onDragObservable here, SixDofDragBehavior does not provide continuous updates like PointerDragBehavior
			dragBehavior.onDragEndObservable.add(() => {
				console.log("3D dragging ended")
			})
		}
		plane.isVisible = visibility
		plane.renderingGroupId = 2
	}
}
